import React from 'react';
import { FormProvider } from '@abyss/web/ui/FormProvider';
import { Grid } from '@abyss/web/ui/Grid';
import { Box } from '@abyss/web/ui/Box';
import { Heading } from '@abyss/web/ui/Heading';
import { TextInput } from '@abyss/web/ui/TextInput';
import { SelectInput } from '@abyss/web/ui/SelectInput';
import { Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { DataTable } from '@abyss/web/ui/DataTable';
import { LoadingOverlay } from '@abyss/web/ui/LoadingOverlay';

import { useToast } from '@abyss/web/hooks/useToast';

import { DataTableExampleController } from './DataTableExample.Controller';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';

export const DataTableExample = () => {
  const { form, tableState, Action, loading } = DataTableExampleController();
  const { toast } = useToast();

  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Design', label: 'Design' },
    { value: 'HR', label: 'Human Resources' },
    { value: 'Finance', label: 'Finance' },
  ];

  return (
    <LoadingOverlay
      loadingTitle="Loading Employees"
      loadingMessage="Fetching employee data..."
      ariaLoadingLabel="Loading employee data"
      isLoading={loading}
    >
      <Box color="$primary2" padding="$md" width="100%">
        {/* <ToastProvider /> */}
        <FormProvider state={form}>
          <Grid>
            <Grid.Col span={{ xs: '100%' }}>
              <Grid>
                <Grid.Col span={{ xs: 12 }}>
                  <Heading display="h4" color="$primary1">
                    Filters
                  </Heading>
                </Grid.Col>
                <Grid.Col span={{ sm: 12, md: 4, lg: 3 }}>
                  <TextInput
                    label="Employee Name"
                    model="name"
                    placeholder="Search by name..."
                  />
                </Grid.Col>
                <Grid.Col span={{ sm: 12, md: 4, lg: 3 }}>
                  <SelectInput
                    label="Department"
                    model="department"
                    placeholder="Select department..."
                    options={departmentOptions}
                  />
                </Grid.Col>
                <Grid.Col span={{ xs: 12 }}>
                  <Layout.Group>
                    <Button
                      type="submit"
                      size="$md"
                      onClick={() => {
                        Action.FilterData();
                      }}
                    >
                      Filter
                    </Button>
                    <Button
                      size="$md"
                      variant="outline"
                      onClick={Action.ResetFilters}
                    >
                      Reset
                    </Button>
                  </Layout.Group>
                </Grid.Col>
              </Grid>
            </Grid.Col>
            <Grid.Col span={{ xs: '100%' }}>
              <Layout.Group alignLayout="between">
                <Heading display="h4" color="$primary1">
                  Employee Management
                </Heading>
                <Button size="$md" variant="solid" onClick={Action.OnCreateNew}>
                  <IconSymbol icon="add" size="$sm" />
                  Create New Employee
                </Button>
              </Layout.Group>
            </Grid.Col>
            <Grid.Col span={{ xs: '100%' }}>
              <DataTable title="" tableState={tableState} hideTitleHeader />
            </Grid.Col>
          </Grid>
        </FormProvider>
      </Box>
    </LoadingOverlay>
  );
};
